import type { ClassReportStudentType, ReportsFilterOptionsType } from '../pages/types';
import type { FilterValueType } from '../global/modals/ReportFilterModal';
import type {
  ReportFilterGenderValue,
  ReportFilterGroupsValue,
  ReportFilterProgressionValue,
  ReportFilterQualityValue,
  ReportFilterStudentsValue,
  ReportFilterTagValue,
} from '../global/modals/ReportFilterModal.views';
import { EXCELLENT_BREAKING_VALUES, EXCESSIVE_BREAKING_VALUES, GOOD_BREAKING_VALUES } from '../components/charts/helpers/vars';

const passesByStudent = (student: ClassReportStudentType, filterValue: ReportFilterStudentsValue): boolean => {
  return (0 < filterValue.student.length && filterValue.student.includes(student.id));
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const passesByGroup = (student: ClassReportStudentType, filterValue: ReportFilterGroupsValue): boolean => {
  // TODO Implement
  return true;
};

const passesByQuality = (student: ClassReportStudentType, filterValue: ReportFilterQualityValue): boolean => {
  switch (filterValue.quality) {
    case 'high':
      return EXCESSIVE_BREAKING_VALUES.qualityLearningTime! < student.chartsData.qualityLearningTime;
    case 'recommended':
      return EXCELLENT_BREAKING_VALUES.qualityLearningTime! <= student.chartsData.qualityLearningTime && EXCESSIVE_BREAKING_VALUES.qualityLearningTime! >= student.chartsData.qualityLearningTime;
    case 'low':
      return EXCELLENT_BREAKING_VALUES.qualityLearningTime! > student.chartsData.qualityLearningTime;
    default:
      return false;
  }
};

const passesByProgression = (student: ClassReportStudentType, filterValue: ReportFilterProgressionValue): boolean => {
  switch (filterValue.progression) {
    case 'good':
      return 3 < student.chartsData.progression;
    case 'moderate':
      return 2 <= student.chartsData.progression && 3 >= student.chartsData.progression;
    case 'below':
      return 2 > student.chartsData.progression;
    default:
      return false;
  }
};

const passesByGender = (student: ClassReportStudentType, filterValue: ReportFilterGenderValue): boolean => {
  switch (filterValue.gender) {
    case 'male':
      return 1 === student.gender;
    case 'female':
      return 2 === student.gender;
    case 'other':
      return 3 === student.gender;
    default:
      return false;
  }
};

const passesByTag = (student: ClassReportStudentType, filterValue: ReportFilterTagValue): boolean => {
  return filterValue.tag ? student.tags.includes(filterValue.tag) : false;
};

const passesFilter = (student: ClassReportStudentType, filterValue: FilterValueType): boolean => {
  if (filterValue === null) return false;

  const [ filter, value ] = Object.entries(filterValue)[0];
  if (!value) return false;

  switch (filter as ReportsFilterOptionsType) {
    case 'student':
      return passesByStudent(student, filterValue as ReportFilterStudentsValue);
    case 'quality':
      return passesByQuality(student, filterValue as ReportFilterQualityValue);
    case 'progression':
      return passesByProgression(student, filterValue as ReportFilterProgressionValue);
    case 'gender':
      return passesByGender(student, filterValue as ReportFilterGenderValue);
    case 'tag':
      return passesByTag(student, filterValue as ReportFilterTagValue);
    default:
      return false;
  }
};

const getClassReportStudentsFiltered = (
  classReportStudents: ClassReportStudentType[],
  filterValue: FilterValueType,
): ClassReportStudentType[] => {
  if (!filterValue) {
    return [];
  }

  return classReportStudents.filter((student) => passesFilter(student, filterValue));
};

export default getClassReportStudentsFiltered;
